import React from 'react';
import { PDFDocument } from './pdf/PDFDocument';

interface ResultsPDFProps {
  simulation: any;
  displayResults: any;
  formData: {
    content: string;
    platform: string;
    sender: string;
    sector: string;
  };
  forecast: any;
  reputationInfo: {
    level: string;
    color: string;
  };
  uiScore: number;
  chartImages?: {
    sentimentChart?: string;
    gaugeChart?: string;
  };
  user?: {
    firstName?: string;
    lastName?: string;
    email?: string;
  };
}

const ResultsPDF: React.FC<ResultsPDFProps> = (props) => {
  return <PDFDocument {...props} />;
};

export default ResultsPDF;